import { FC } from 'react'

import CONFIG from '../../../../config'
import { FormResponseStatus } from '../../../models'
import { Layout } from '../../../containers'
import { Card, Modal, Title, useModal, FormMessageError, LinkBack } from '../../../components/UI'
import { AdminControlPreventionForm, AdminControlPreventionFormSuccess } from '../../../components'

const AdminControlPreventionCreatePage:FC = () => {
  const modal = useModal()

  const onFormSubmitChange = (status: FormResponseStatus, message: string = '') => {
    modal.setStatus(status)
    modal.setMessage(message)
    modal.open()
  }

  return (
    <Layout role="ADMIN_ROLE">
      <div className="container register-wrapper pt-50 pb-70">
        <div className="d-flex justify-content-between">
          <Title border>Crear control y prevención</Title>

          <LinkBack link={CONFIG.ROUTES.ADMIN.CONTROLPREVENTION.HOME} />
        </div>

        <Card showOnly="lg" className="lg:py-70 lg:px-70 mt-50 lg:mt-25">
          <AdminControlPreventionForm
            onSubmitChange={(status, message) => onFormSubmitChange(status, message)}
          />
        </Card>
      </div>

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' &&
          <AdminControlPreventionFormSuccess
            className="py-60 px-100"
            buttonText="REGISTRAR OTRO POST"
            onClick={() => modal.close()}
          />
        }
        {modal.status === 'ERROR' &&
          <FormMessageError
            className="py-60 px-50"
            message="No ha sido posible completar el registro"
            onClick={() => modal.close()}
          />
        }
      </Modal>
    </Layout>
  )
}

export { AdminControlPreventionCreatePage }